export enum DigitalTwinInstanceStatus {
    Starting = "Starting",
    Stopped = "Stopped",
    Occupied = "Occupied",
    Available = "Available",
    Error = "Error",
    Stopping = "Stopping"
}